import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import Place from 'material-ui/svg-icons/maps/place';
import style from '../../../styles/styles';
import muiThemeable from 'material-ui/styles/muiThemeable';
import MediasService from '../../../services/medias';
import {POINT_PAGE} from "../../../constants/routes";
import { Chip } from 'material-ui';
import styles from '../../page/PageItem.css';
import ActionVisibleOff from 'material-ui/svg-icons/action/visibility-off';

class Point extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        point: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        handleRemovePoint: PropTypes.func,
    };

    // Handlers

    handleRemovePoint = () => {
        this.props.handleRemovePoint(this.props.point);
    };

    onSwitchFavorite = () => {
        this.props.point.is_favorite = !this.props.point.is_favorite;
    };

    // Render

    renderFirstMedia() {
        let point = this.props.point;

        if (point.medias) {
            let images = MediasService.sortedMediasForShortMime(point.medias, MediasService.IMAGES);

            if (images.length > 0) {
                return <Avatar src={images[0].link} style={style.image.cover}/>;
            }
        }

        return <Avatar icon={<Place/>}/>;
    }

    render() {
        const {point} = this.props;
        return (
            <Link to={POINT_PAGE.replace(':appId', this.props.app.id).replace(':pointId', this.props.point.id)}>
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderFirstMedia()}
                    rightIcon={!point.visible && <ActionVisibleOff />}
                    primaryText={
                        <div>
                            {point.name || 'No name'}
                            {point.tag &&
                            <Chip style={{...styles.chip, ...style.chip}}>
                                {point.tag}
                            </Chip>
                            }
                        </div>
                    }
                    disableKeyboardFocus={true}
                >
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(Point);



// WEBPACK FOOTER //
// src/components/openexplore/Point/Point.js